import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';
import Icon from 'react-fa';

import CrossChannelActions from '../../../actions/CrossChannelActions';

import CostInput from './CostInput.react';
import NumberInput from './NumberInput.react';
import PercentageOptions from './PercentageOptions.react';
import ImpactFactorInput from './ImpactFactorInput.react';

export default class ModeOptionCard extends React.Component {
  constructor(props) {
    super(props);

    this.updateMode = CrossChannelActions.updateMode
      .bind(this, props.organizationId, props.mode.key);

    this.updateSelected = this.updateMode.bind(this, 'selected');
    this.updateCost = this.updateMode.bind(this, 'cost');
    this.updateFrequency = this.updateMode.bind(this, 'frequency');
    this.updatePercentage = this.updateMode.bind(this, 'percentage');
    this.updatePercentageType = this.updateMode.bind(this, 'percentageType');
    this.updateImpactFactor = this.updateMode.bind(this, 'impactFactor');
    this.updateDiscount = this.updateMode.bind(this, 'discount');

    this.updateFlightSize = this.updateMode.bind(this, 'flightSize');
  }

  render() {
    return (
      <Col lg={4} md={6} sm={12} className={this.props.mode.selected ? '' : 'hide'}>
        <Col md={12} className='card-well'>
          { this.props.mode.selected && (
            <div>
              <div className='text-center mode-header'>
                <Icon name={this.props.mode.icon} size='3x' className='text-primary' />
                <h3>{this.props.mode.displayLabel}</h3>
              </div>

              <div className='mode-body'>
                <CostInput
                  mode={this.props.mode}
                  updateCost={this.updateCost}
                  updateSelected={this.updateSelected}
                />
                <NumberInput
                  onChange={this.updateFrequency}
                  value={this.props.mode.frequency}
                  min='1'
                  helperText={this.props.mode.frequencyText}
                  tooltip={this.props.mode.frequencyTooltip}
                />
                <PercentageOptions
                  mode={this.props.mode}
                  updatePercentage={this.updatePercentage}
                  updatePercentageType={this.updatePercentageType}
                />
                { this.props.mode.flightText &&
                  <NumberInput
                    onChange={this.updateFlightSize}
                    value={this.props.mode.flightSize}
                    min='1'
                    step='1'
                    helperText={this.props.mode.flightText}
                    tooltip={this.props.mode.flightTooltip}
                  />
                }

                { this.props.advancedSettings &&
                  <div className='mode-advanced'>
                    <ImpactFactorInput
                      mode={this.props.mode}
                      updateImpactFactor={this.updateImpactFactor}
                    />
                    <NumberInput
                      onChange={this.updateDiscount}
                      value={this.props.mode.discount}
                      min='0.05'
                      max='1'
                      step='0.05'
                      helperText='Discount Factor'
                      tooltip={this.props.mode.discountTooltip}
                    />
                  </div>
                }

              </div>
            </div>
          )}
        </Col>
      </Col>
    );
  }
}

ModeOptionCard.propTypes = {
  mode: PropTypes.object,
  organizationId: PropTypes.number,
  advancedSettings: PropTypes.bool,
};
